export { default } from './Account';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/Account/index.js